/**
 * FreeSpinsTotalWinPanel
 *
 *
 */
(function () {
  class FreeSpinsTotalWinPanel extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;
      this._panel = undefined;
      this._multiplier = 1;
      this._value = 0;
      this._moved = false;
      this._countingUp = false;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._textContainer = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer'
      );
      this._combinedTextContainer = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer'
      );

      // value
      this._valueContainer = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:valueContainer'
      );
      this._valueText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:valueContainer:valueText'
      );
      this._valueGoldText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:valueContainer:valueGoldText'
      );

      // final value
      this._finalValueContainer = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:finalValueContainer'
      );
      this._finalValueText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:finalValueContainer:finalValueText'
      );
      this._finalValueGoldText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:finalValueContainer:finalValueGoldText'
      );

      // x
      this._xContainer = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:xContainer'
      );
      this._xText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:xContainer:xText'
      );
      this._xGoldText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:xContainer:xGoldText'
      );

      // multiplier
      this._multiplierContainer = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:multiplierContainer'
      );
      this._multiplierText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:multiplierContainer:multiplierText'
      );
      this._multiplierGoldText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:multiplierContainer:multiplierGoldText'
      );

      // max win
      this._maxWinText = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:maxWinText'
      );

      // explosion
      this._explosion = resourceManager.get(
        'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:explosion'
      );

      // panel
      this._panel = resourceManager.get('slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:panel');

      this.reset();

      Reflex.addToUpdate((delta) => {
        this.update(delta);
      });
    }

    // needs to be called when ever the multiplier has been set
    positionOtherTextsAsRequired(multiplier) {
      const padding = 15;

      this._multiplierText.setText(`${multiplier}`);
      this._multiplierGoldText.setText(`${multiplier}`);

      // we need to make sure the x is in the correct position in relation to the value
      const valueWidth = this._valueText.width * this._valueText.scale.x;
      const xWidth = this._xText.width * this._xText.scale.x;
      const multiplierWidth = this._multiplierText.width * this._multiplierText.scale.x;

      // we have all the widths now
      // we should be able to position xText and multiplierText
      const xTextX = this._valueText.x + valueWidth / 2 + xWidth / 2 + padding;
      this._xText.x = xTextX;
      this._xGoldText.x = xTextX;

      const multiplierTextX = xTextX + xWidth / 2 + multiplierWidth / 2 + padding;
      this._multiplierText.x = multiplierTextX;
      this._multiplierGoldText.x = multiplierTextX;

      const totalWidths = {
        valueWidth: valueWidth,
        xWidth: xWidth,
        multiplierWidth: multiplierWidth,
        padding: padding,
        total: valueWidth + xWidth + multiplierWidth + padding + padding,
      };

      return totalWidths;
    }

    centreCombined(widths) {
      let moveLeftBy = widths.padding * 2;
      moveLeftBy += widths.xWidth;
      moveLeftBy += widths.multiplierWidth;
      moveLeftBy /= 2;
      this._combinedTextContainer.x = -moveLeftBy;
    }

    async moveValue(multiplier) {
      // we should be able to move just the 1 container
      // combinedTextContainer
      if (!this._moved) {
        // before we do anything
        // and as this is the 1st multiplier being added
        // set the value on the bitmap fonts so we can calc the width
        const totalWidths = this.positionOtherTextsAsRequired(multiplier);
        // we have total widths
        // we need to position combinedTextContainer, so the whole thing looks centered
        // how much do we need to move to the left by?
        // isnt this just the padding and the 2 new text?
        let moveLeftBy = totalWidths.padding * 2;
        moveLeftBy += totalWidths.xWidth;
        moveLeftBy += totalWidths.multiplierWidth;
        moveLeftBy /= 2;

        this._xContainer.visible = true;
        this._xContainer.alpha = 0;
        game.tweenFromToAsync(
          this._xContainer,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.25,
          }
        );

        const width = this._combinedTextContainer;
        // this should make it so when the 1st multiplier is added, they are in the middle
        await game.tweenFromToAsync(
          this._combinedTextContainer,
          {
            x: this._combinedTextContainer.x,
          },
          {
            x: -moveLeftBy,
            duration: 0.25,
          }
        );
        this._moved = true;
      }
    }

    async scaleMultiplier() {
      await game.tweenFromToAsync(
        this._multiplierContainer.scale,
        {
          y: 1,
        },
        {
          y: 1.4,
          duration: 0.15,
          repeat: 3,
          yoyo: true,
        }
      );
    }

    update(delta) {
      // dont think we are too fussed about the delta
      // if (this._countingUp === true) {
      //   // now we need to figure out how to position the textContainer,
      //   // so the value appears in the middle
      //   this.centreTextContainer();
      // }
    }

    // centreTextContainer() {
    //   //
    //   if (!this._moved) {
    //     const scale = 0.8;
    //     const containerWidth = this._valueContainer.width * scale;
    //     const containerWidthHalf = Math.floor(containerWidth / 2);
    //     const magicXOffset = 46 * scale;
    //     const x = containerWidthHalf - magicXOffset;
    //     this._combinedTextContainer.x = x;
    //     console.log('x is', x);
    //   }
    // }

    addMultiplier(muliplier, updateText = true) {
      this._multiplier += muliplier;

      this._xContainer.visible = true;
      this._multiplierContainer.visible = true;

      if (updateText) {
        if (this._multiplier >= 20) {
          // we need to switch over to the gold text
          this._valueText.visible = false;
          this._valueGoldText.visible = true;
          this._finalValueText.visible = false;
          this._finalValueGoldText.visible = true;
          this._xText.visible = false;
          this._xGoldText.visible = true;
          this._multiplierText.visible = false;
          this._multiplierGoldText.visible = true;
        }

        // this._multiplierText.setText(`${this._multiplier}`);
        // this._multiplierGoldText.setText(`${this._multiplier}`);
        // this.positionOtherTextsAsRequired updates the text!!!!!!!!
        const widths = this.positionOtherTextsAsRequired(this._multiplier);
        this.centreCombined(widths);

        this.scaleMultiplier();
      }
    }

    getMultiplier() {
      return this._multiplier;
    }

    async countUp(amountToAdd, durationInMS, isCapped) {
      // do the count up
      // amountToAdd *= 1000000;
      this._value += amountToAdd;

      if (isCapped) {
        this._valueContainer.visible = false;
        this._xContainer.visible = false;
        this._multiplierContainer.visible = false;
        this._finalValueContainer.visible = false;
        this._maxWinText.visible = true;
      } else {
        this._countingUp = true;
        this._valueText.countUp(amountToAdd, durationInMS, () => {
          this._countingUp = false;
          this.positionOtherTextsAsRequired(200);
        });
        this._valueGoldText.countUp(amountToAdd, durationInMS);
        this._finalValueText.countUp(amountToAdd, durationInMS);
        this._finalValueGoldText.countUp(amountToAdd, durationInMS);
      }
    }

    reset() {
      this._valueText.set(0);
      this._valueText.visible = true;
      this._finalValueText.set(0);
      this._finalValueText.visible = true;
      this._xText.visible = true;
      this._multiplierText.setText('');
      this._multiplierText.visible = true;
      this._valueGoldText.set(0);
      this._valueGoldText.visible = false;
      this._finalValueGoldText.set(0);
      this._finalValueGoldText.visible = false;
      this._xGoldText.visible = false;
      this._multiplierGoldText.setText('');
      this._multiplierGoldText.visible = false;
      this._maxWinText.visible = false;
      this._moved = false;

      this._combinedTextContainer.x = 0;

      this._valueContainer.visible = true;
      this._xContainer.visible = false;
      this._multiplierContainer.visible = false;
      this._finalValueContainer.visible = false;
    }

    async show(durationInMS = 100) {
      this.visible = true;
      this._value = 0;
      this._multiplier = 0;

      this._panel.alpha = 0;
      this._textContainer.alpha = 0;

      await game.tweenFromToAsync(
        [this._panel, this._textContainer],
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: durationInMS / 1000,
          ease: 'none',
        }
      );
    }

    getValue() {
      return this._value;
    }
    async setFinalValue(finalValue, cbWhenChanging = null, isCapped) {
      soundManager.play('showFinalValue');

      const moviePromise = game.playMovie(this._explosion);

      await timerManager.delayAsync(250);

      this._valueContainer.visible = false;
      this._xContainer.visible = false;
      this._multiplierContainer.visible = false;
      this._finalValueContainer.visible = true;
      this._moved = false;

      if (cbWhenChanging !== null) {
        cbWhenChanging();
      }

      this._finalValueText.set(finalValue);
      this._finalValueGoldText.set(finalValue);

      if (isCapped) {
        this._valueContainer.visible = false;
        this._xContainer.visible = false;
        this._multiplierContainer.visible = false;
        this._finalValueContainer.visible = false;
        this._maxWinText.visible = true;
      }

      await moviePromise;
    }

    async hide(durationInMS = 100, reset = false) {
      await game.tweenFromToAsync(
        [this._panel, this._textContainer],
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: durationInMS / 1000,
          ease: 'none',
        }
      );

      this.visible = false;
      if (reset === true) {
        this.reset();
      }
    }
  }

  let create = function (json) {
    return new FreeSpinsTotalWinPanel();
  };

  let initialise = function (json, container, resources) {
    container.initialise();
  };

  let getFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('FreeSpinsTotalWinPanel', create, initialise, getFilesRequired);
})();
